/** Integer helpers that stay exact up to 2^53 (tree sizes exceed 2^32 in principle, so no `>>`). */
export const isOdd = (n: number): boolean => n % 2 === 1;
export const half = (n: number): number => Math.floor(n / 2);
export const isPowerOfTwo = (n: number): boolean => n > 0 && Math.log2(n) % 1 === 0;

/** Largest power of two strictly less than n (n >= 2). */
export function largestPowerOfTwoBelow(n: number): number {
  if (n < 2) throw new RangeError('n must be >= 2');
  return 2 ** Math.floor(Math.log2(n - 1));
}

/** Number of trailing zero bits of n (n > 0). */
export function trailingZeros(n: number): number {
  let t = 0;
  while (n % 2 === 0) {
    n = n / 2;
    t++;
  }
  return t;
}
